import { useMemo } from "react";
import TableDataModal from "@/ui/modals/TableDataModal";
import { Product } from "@/shared/core-products";

interface ModalProductDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  selectedProduct: Product;
}

const ModalProductDetails: React.FC<ModalProductDetailsProps> = ({
  isOpen,
  onClose,
  selectedProduct,
}) => {
  const selectedProductType = useMemo(
    () => (selectedProduct?.externalProduct ? "Local" : "ERP"),
    [selectedProduct],
  );
  const additionalItems = useMemo(() => {
    if (selectedProductType === "Local") {
      return [
        {
          label: "Comentario",
          value: selectedProduct?.externalProduct?.comment || "-",
        },
        {
          label: "Precio de compra",
          value:
            selectedProduct?.externalProduct?.purchasePrice?.toString() || "-",
        },
        {
          label: "Stock maximo",
          value:
            selectedProduct?.externalProduct?.maximumStock?.toString() || "-",
        },
      ];
    }
    return [];
  }, [selectedProduct, selectedProductType]);
  return (
    <TableDataModal
      title="Detalles del producto"
      content={[
        {
          items: [
            {
              label: "Descripción",
              value: selectedProduct?.description,
            },
            {
              label: "Unidad",
              value: selectedProduct?.unit,
            },
            {
              label: "Ubicación",
              value: selectedProduct?.location,
            },
            {
              label: "Stock",
              value: selectedProduct?.stock.toString(),
            },
            {
              label: "Stock minimo",
              value: selectedProduct?.minimumStock.toString(),
            },
            {
              label: "Convertidor",
              value: selectedProduct?.converter.toString(),
            },
            {
              label: "Tipo convertidor",
              value: selectedProduct?.converterType.name,
            },
            {
              label: "Bodega",
              value: selectedProduct?.storage.name,
            },
            {
              label: "Tipo de producto",
              value: selectedProductType,
            },
          ],
        },
        {
          items: [
            {
              label: "Código",
              value:
                selectedProduct?.externalProduct?.code ||
                selectedProduct?.erpProduct?.erpCode,
            },
            ...additionalItems, // Agrega los items adicionales condicionales
          ],
        },
      ]}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default ModalProductDetails;
